import React from 'react';
import Modal from './Modal';
import { DeviceRowItem, DeviceRows } from './CapTypeBadges';

/** 设备清单弹窗 (「N 台」点开看明细): 样式与 工艺类型 · 具备该工艺的设备 弹窗一致. */
const DeviceListModal = ({
    open,
    title,
    hint,
    devices,
    tag,
    onClose,
}: {
    open: boolean;
    title: string;
    /** 标题下的说明文案 */
    hint?: React.ReactNode;
    devices: DeviceRowItem[];
    /** 每行右侧的标签 */
    tag?: string;
    onClose: () => void;
}) => (
    <Modal open={open} width={560} title={title} onClose={onClose}>
        <div className="p-5">
            {hint && <div className="text-xs text-slate-500 mb-3">{hint}</div>}
            {devices.length === 0 ? (
                <div className="text-center text-slate-400 text-sm py-8">
                    暂无设备
                </div>
            ) : (
                <DeviceRows devices={devices} tag={tag} onNavigate={onClose} />
            )}
            <div className="flex justify-end mt-4">
                <button type="button" className="btn-ghost" onClick={onClose}>
                    关闭
                </button>
            </div>
        </div>
    </Modal>
);

export default DeviceListModal;
